<template>
    <div>
        <v-card-subtitle class="title px-0 mx-0">{{ $t('mainStore.personalize.aboutUs.title') }}</v-card-subtitle>
        <v-row>
            <v-col cols="12" md="2">
                <div class="d-flex justify-space-between pb-9">
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('text-image')" style="width: 80px"><v-icon color="primary">mdi-text</v-icon><v-icon color="primary">mdi-image</v-icon></v-btn>
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('image-text')" style="width: 80px"><v-icon color="primary">mdi-image</v-icon><v-icon color="primary">mdi-text</v-icon></v-btn>
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('image')" style="width: 80px"><v-icon color="primary" class="mx-3">mdi-image</v-icon></v-btn>
                </div>
                <div class="d-flex justify-space-between pb-9">
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('text')" style="width: 80px"><v-icon color="primary" class="mx-3">mdi-text</v-icon></v-btn>
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('charts')" style="width: 80px" :disabled="hasChart"><v-icon color="primary" class="mx-3">mdi-chart-bar</v-icon></v-btn>
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('video')" style="width: 80px"><v-icon color="primary" class="mx-3">mdi-youtube</v-icon></v-btn>

                    
                </div>
                <!-- <div class="d-flex justify-space-between pb-9">
                    <v-btn outlined color="grey lighten-2" class="py-9" @click="add('image')"><v-icon color="primary" class="mx-3">chart-bar</v-icon></v-btn>
                </div> -->
                
                <!-- <div class="pt-9 pb-0">
                    <v-btn block color="primary" elevation="0" @click="save()">{{ $t('common.save') }}</v-btn>
                </div> -->
            </v-col> 
            <v-divider vertical></v-divider>
            <v-col cols="12" md="10">
                <div v-if="processing"></div>
                <template v-else>

                <div class="pa-1" v-for="(item, index) in scheme" :key="index">
                    <v-card  class="pa-3" v-if="item.type == 'text'">
                        <div class="d-flex" style="width: 100%">
                            <v-btn icon @click="goUp(index)" :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn icon @click="goDown(index)" :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </div>

                        <v-row class="pa-0 ma-0">
                            <v-col class="pa-2 ma-0" cols="12" md="12" sm="12">
                                <v-tiptap v-model="item.values[0]" :label="$t('mainStore.personalize.aboutUs.labelText1')" :toolbar='editorConfig' />
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card  class="pa-3" v-if="item.type == 'video'">
                        <div class="d-flex" style="width: 100%">
                            <v-btn icon @click="goUp(index)" :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn icon @click="goDown(index)" :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </div>

                        <v-row class="pa-0 ma-0">
                            <v-col class="pa-2 ma-0" cols="12" md="12" sm="12">
                                <v-text-field label="You tube link" v-model="item.values[0]"></v-text-field>
                                <iframe width="100%" max-width="550" height="412"
                                    :src="`https://www.youtube-nocookie.com/embed/${getVideoId(item.values[0])}`" title="YouTube video player"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowfullscreen></iframe>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="pa-3" v-if="item.type == 'image'">
                        <div class="d-flex" style="width: 100%">
                            <v-btn icon @click="goUp(index)" :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn icon @click="goDown(index)" :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-spacer></v-spacer>
                            <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </div>

                        <v-row class="pa-0 ma-0">
                            <v-col class="pa-0 ma-0" cols="12" md="12" sm="12">
                                <FireUpload mime="'image/*'" :path="'/about/'" :type="'image'" @change-url="item.values[0] = $event"
                                    :snap="item.values[0]"></FireUpload>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="pa-3" v-if="item.type == 'text-image'">
                        <div class="d-flex" style="width: 100%">
                            <v-btn icon @click="goUp(index)" :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn icon @click="goDown(index)" :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-spacer></v-spacer>
                            <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </div>
                        <v-row class="pa-0 ma-0">
                            <v-col class="pa-2 ma-0" cols="12" md="6" sm="12">
                                <v-tiptap v-model="item.values[0]" :label="$t('mainStore.personalize.aboutUs.labelText1')" :toolbar='editorConfig' />
                            </v-col>
                            <v-col class="pa-0 ma-0" cols="12" md="6" sm="12">
                                <FireUpload mime="'image/*'" :path="'/about/'" :type="'image'" @change-url="item.values[1] = $event"
                                    :snap="item.values[1]"></FireUpload>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="pa-3" v-if="item.type == 'image-text'">
                        <div class="d-flex" style="width: 100%">
                            <v-btn icon @click="goUp(index)" :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn icon @click="goDown(index)" :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-spacer></v-spacer>
                            <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </div>

                        <v-row class="pa-0 ma-0">
                            <v-col class="pa-0 ma-0" cols="12" md="6" sm="12">
                                <FireUpload mime="'image/*'" :path="'/about/'" :type="'image'" @change-url="item.values[0] = $event"
                                    :snap="item.values[0]"></FireUpload>
                            </v-col>
                            <v-col class="pa-2 ma-0" cols="12" md="6" sm="12">
                                <v-tiptap v-model="item.values[1]" :label="$t('mainStore.personalize.aboutUs.labelText1')" :toolbar='editorConfig' />
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-card class="pa-3" v-if="item.type == 'charts'">
                        <div class="d-flex" style="width: 100%">
                            <v-btn icon @click="goUp(index)" :disabled="index == 0"><v-icon>mdi-arrow-up</v-icon></v-btn>
                            <v-btn icon @click="goDown(index)" :disabled="scheme.length - 1 == index"><v-icon>mdi-arrow-down</v-icon></v-btn>
                            <v-spacer></v-spacer>
                            <v-spacer></v-spacer>
                            <v-btn icon color="error" @click="remove(item)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                        </div>

                        <v-row class="pa-0 ma-0">
                            <v-col class="pa-0 ma-0" cols="12" md="12" sm="12">
                                <div class="d-flex" style="width: 100%">
                                    <v-card class="pa-9 mt-2 text-center" outlined width="100%">
                                        <p>{{ $t('mainStore.aboutStore.ageGroup.title') }}</p>
                                        <v-icon class="mx-auto">mdi-poll</v-icon>
                                    </v-card>
                                    <v-card class="pa-9 mt-2 mx-2 text-center" outlined width="100%">
                                       <p>{{ $t('mainStore.aboutStore.gender.title') }}</p>
                                       <v-icon class="mx-auto">mdi-poll</v-icon>

                                    </v-card>
                                    <v-card class="pa-9 mt-2 text-center" outlined width="100%">
                                        <p>{{ $t('mainStore.aboutStore.SL.title') }}</p>
                                        <v-icon class="mx-auto">mdi-poll</v-icon>

                                    </v-card>
                                </div>
                            </v-col>
                            
                        </v-row>
                    </v-card>
                    
                </div>
            </template>

            </v-col>
        </v-row>

    </div>
</template>
<script>
import FireUpload from '@/interface/FireUpload.vue';
import { mapState } from "vuex";
import moment from 'moment'
export default {
    name: "AboutUsSection",
    components: { FireUpload },
    data: () => ({
        processing: false,
        editorConfig: [
                                    "bold",
                                    "italic",
                                    "underline",
                                    "color",
                                    "|",
                                    "headings",
                                    "|",
                                    "left",
                                    "center",
                                    "right",
                                    "justify",
                                    "|",
                                    "bulletList",
                                    "orderedList",
                                    "|",
                                    "link",
                                    "emoji",
                                    "|",
                                    "clear",
                                ],
        form: {
            text1: "",
            text2: "",
            image1: "",
            image2: ""
        },
        scheme: []
    }),
    props: {
        snap: [Object, Array]
    },
    
    mounted() {
        if(Array.isArray(this.snap))
        this.scheme = JSON.parse(JSON.stringify(this.snap))
        else
        this.scheme = []
    },
    watch: {
        'selectedStore': {
            deep: true,
            haldler() {
                this.load()
            }
        },
        'scheme': {
            deep: true,
            handler(){
                this.save()
            }
        }
        

    },

    computed: {
        ...mapState("groupStores", [
            "selectedStore",
        ]),
        hasChart(){
            let res = false
            this.scheme.forEach((item) => {
                if(item.type == 'charts'){
                    res = true
                }
            })
            return res
        }

    },
    methods: {
        save(){
            this.$emit('update-store', this.scheme)
       
        },
        getVideoId(url){
            const searchParams = new URLSearchParams(url);
            if(searchParams.has('v')){
                const v = searchParams.get('v')
                return v
            }
            else{
                if(url.includes('v=')){
                    const p = url.split('v=')
                    const r = p[1].includes('&') ? p[1].split('&')[0] : p[1]
                    return r
                }
            }
        },
        goUp(index){
            this.processing = true
            const prevF = JSON.parse(JSON.stringify(this.scheme[index-1]))
            const prevL = JSON.parse(JSON.stringify(this.scheme[index]))
            console.log(`o item [${index-1}] agora é `, prevL)
            console.log(`o item [${index}] agora é `, prevF)
            this.scheme[index-1] = prevL
            this.scheme[index] = prevF
            setTimeout(() => {
                this.processing = false
            },10)
        },
        goDown(index){
            this.processing = true

            const prevF = JSON.parse(JSON.stringify(this.scheme[index+1]))
            const prevL = JSON.parse(JSON.stringify(this.scheme[index]))
            console.log(`o item [${index+1}] agora é `, prevL)
            console.log(`o item [${index}] agora é `, prevF)
            this.scheme[index+1] = prevL
            this.scheme[index] = prevF
            setTimeout(() => {
                this.processing = false
            },10)
        },
        add(type){
            const id = moment().format('X')
            switch(type){
                case 'image':
                this.scheme.push({type: 'image', values: [""], id: id})
                break;
                case 'text':
                this.scheme.push({type: 'text', values: [""], id: id})
                break;
                case 'video':
                this.scheme.push({type: 'video', values: [""], id: id})
                break;
                case 'text-image':
                this.scheme.push({type: 'text-image', values: ["", ""], id: id})
                break;
                case 'image-text':
                this.scheme.push({type: 'image-text', values: ["", ""], id: id})
                break;
                case 'charts':
                this.scheme.push({type: 'charts', values: ["", ""], id: id})
                break;
            }
        },
        remove(item){
            const findIndex = this.scheme.findIndex(i => i.id == item.id)
            this.scheme.splice(findIndex, 1);
        },
        load() {
            const form = this.snap
            

        },
    }

}
</script>